import type { Attempt } from "../types/course";
import { CONTENT_VERSION } from "../content/version";

export function learningDay(timestamp: number) {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Shanghai",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(timestamp);
}
export function streak(days: string[], now = Date.now()) {
  const dayMs = 86_400_000;
  const today = Date.parse(learningDay(now));
  const known = new Set(days);
  let cursor = known.has(new Date(today).toISOString().slice(0, 10))
    ? today
    : today - dayMs;
  let count = 0;
  while (known.has(new Date(cursor).toISOString().slice(0, 10))) {
    count++;
    cursor -= dayMs;
  }
  return count;
}
export function mistakeHistory(
  attempts: Attempt[],
  contentVersion = CONTENT_VERSION,
) {
  const results = new Map<
    string,
    { mastered: boolean; times: number; quizId: string }
  >();
  for (const attempt of [...attempts]
    .filter((item) => item.status === "submitted")
    .sort(
      (a, b) => (a.submittedAt ?? a.startedAt) - (b.submittedAt ?? b.startedAt),
    )) {
    for (const result of attempt.results) {
      const previous = results.get(result.questionId);
      if (!result.correct || previous)
        results.set(result.questionId, {
          // Old success remains historical, not evidence that the revised
          // question is mastered. Importing an older attempt later must also
          // not undo a current-version successful retry.
          mastered:
            attempt.contentVersion === contentVersion
              ? result.correct
              : (previous?.mastered ?? false),
          times: (previous?.times ?? 0) + (result.correct ? 0 : 1),
          quizId: attempt.quizId,
        });
    }
  }
  return results;
}
